import { render, staticRenderFns } from "./AssignAgentModal.vue?vue&type=template&id=2a59d9e8&scoped=true&"
import script from "./AssignAgentModal.vue?vue&type=script&lang=js&"
export * from "./AssignAgentModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignAgentModal.vue?vue&type=style&index=0&id=2a59d9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59d9e8",
  null
  
)

export default component.exports